import { capitalDesignTokens } from './capital_design_tokens';

const tokens = capitalDesignTokens.foundations.colors;

/**
 * Capital categorical chart palette. Use for discrete, unordered categories
 * — pie slices, grouped bars, side-by-side comparisons. Ordered for maximum
 * perceptual separation between adjacent indices.
 *
 * Source: extended palette in `capital-design-tokens` (Indigo, Periwinkle,
 * Jade, Port, Rose, Magenta, Orange, Terracotta, Blue, Cerulean, In Progress).
 */
export const capitalCategoricalPalette: string[] = [
  tokens.indigo600,
  tokens.terracotta600,
  tokens.jade600,
  tokens.magenta600,
  tokens.cerulean600,
  tokens.orange600,
  tokens.periwinkle600,
  tokens.rose600,
  tokens.port600,
  tokens.blue600,
  tokens.purple600
];
